import React, {useEffect, useState} from 'react';
import {DetailGrid} from '@/components/GridWidget';
import {WdiCardTitle} from '@/components/WdiControls';
import {initFieldDisplayFormater, TableColumnRanderFormats} from '@/components/WdiBus/TableColumnRanderFormats';
import {NsGrid} from '@/components/GridWidget/GridDefProps';
import {WdiPanel} from '@/components/WdiControls/WdiPanel';
import {Enum} from '@/enums/system';
import {GridApi} from '@/services/gridapi';
import useWindowSize from "@/utils/useWindowSize";

export type DetailForApplyProps = {
  data?: any,
  dataSource: any[],
  onChange?: (dataSource: any) => void;
}


export const PrePaymentDetailsForApprovalPanel: React.FC<DetailForApplyProps> = (props) => {

  /// Grid初始化配置，GridSettings请求完数据之后再进行加载
  const [isLoaded, setIsLoaded] = useState(false);
  const [gridSettings, setGridSettings] = useState<any>({});
  const {dataSource} = props;
  const {width} = useWindowSize();


  useEffect(() => {
    GridApi.searchConfig({id: 'FormSPDetailForPreApproval', allowModifyColumns: true}).then((response) => {
      const settings: any = Object.assign({}, response.data, {
        actionsAlign: NsGrid.ActionsAlign.None,
        showAggr: true,
        showExpandedRow: true,
      });

      initFieldDisplayFormater(settings.formSchema.allFields);
      settings.formSchema.allFields.amountInVat.aggr = TableColumnRanderFormats.sumAggr('amountInVat', 2);
      settings.formSchema.allFields.rowNumber.width = 80;

      setGridSettings(settings);
      setIsLoaded(true);
    });
  }, []);

  const pageGridSettings = Object.assign({width: width - 270}, gridSettings);
  pageGridSettings.antdProps = {
    dataSource,
    initRowFieldConfigs: () => {
      return ['rowNumber','ecName','amountInVat','remark','tpmSpDetailId','exportStatusName','exportDate','voucherNo','amountOriginal']
    },
    pagination: {
      defaultPageSize: 10,
      showSizeChanger: true
    },
  };

  return (
    <WdiPanel title={<WdiCardTitle iconType={Enum.IconType.DETAIL_INFO} title='费用明细信息'/>} collapsed={true}>
      {isLoaded && <DetailGrid {...pageGridSettings} />}
    </WdiPanel>
  );
};

export default PrePaymentDetailsForApprovalPanel;

